import qs from'qs';import {useMemo}from'react';import {useLocation}from'react-router-dom/cjs/react-router-dom.min';/**
 * Get a context parameter from either the top-level CIAM domain, or from inside the goto context
 *
 * If the paramter is present in both, the top-level takes precedence
 *
 * @param {string} paramName The name of the param in both the top level and context
 * @returns The value of the param if it exists, otherwise null.
 */
function useCIAMContextParam(paramName) {
  var location = useLocation();
  var value = useMemo(function () {
    try {
      // First use the top-level search param value if it exists
      var params = qs.parse(location.search, {
        ignoreQueryPrefix: true
      });
      if (params[paramName]) {
        return params[paramName];
      }

      // Then try the search value inside the goto context
      var gotoUrl = new URL(params.goto);
      var gotoParams = qs.parse(gotoUrl.search, {
        ignoreQueryPrefix: true
      });
      if (gotoParams[paramName]) {
        return gotoParams[paramName];
      }

      // Finally, fall back to nothing
      return null;
    } catch (_unused) {
      return null;
    }
  }, [location, paramName]);
  return value;
}export{useCIAMContextParam as default};